import PropTypes from "prop-types";

export default PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({id: PropTypes.string.isRequired}),
]);